import React from "react";

const QuotationStatus = ({ quotation }) => {
  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(date));
  };

  return (
    <div className="quotation-status-row">
      <div>
        <span className="quotation-label">Quotation Number</span>

        <strong>#{quotation?.quotationNumber || "-"}</strong>
      </div>

      <div>
        <span className="quotation-label">Issue Date</span>

        <strong>{formatDate(quotation?.issueDate)}</strong>
      </div>

      <div>
        <span className="quotation-label">Valid Until</span>

        <strong>{formatDate(quotation?.validUntil)}</strong>
      </div>

      <div>
        <span
          className={`status-badge ${quotation?.status?.toLowerCase() || ""}`}
        >
          {quotation?.status === "SENT"
            ? "Decision Pending..."
            : quotation?.status || "-"}
        </span>
      </div>
    </div>
  );
};

export default QuotationStatus;
